// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1xOLu","footer":"ChangeClinic_footer__KA4yf"};